// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2SVRV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2eeDS"};